import { Component, Inject, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings, AppSvgIcons, StorageUtilityLib, USER_SESSION_TOKEN, UserSession } from '@thehubz/client/core';
import { AuthApiService } from '@thehubz/client/data-access-api';

@Component({
  selector: 'wl-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  refreshTokenTime = AppSettings.REFRESH_TOKEN_CHECK_INTERVAL;

  constructor(
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private authService: AuthApiService,
    private storageUtility: StorageUtilityLib,
  ) {
    const logoPath = 'assets/logos';

    const customSvgIcons = {
      'sp-brand': `${logoPath}/SP_LOGO_RGB.svg`,
      'sp-makeos-white': `${logoPath}/SP_MAKEOS_Logo_White.svg`,
      'sp-makeos-black': `${logoPath}/SP_MAKEOS_Logo_black.svg`,
    };

    const svgIcons = Object.assign({}, AppSvgIcons, customSvgIcons);

    for (const [iconName, iconSrc] of Object.entries(svgIcons)) {
      iconRegistry.addSvgIcon(iconName, sanitizer.bypassSecurityTrustResourceUrl(iconSrc));
    }
  }

  ngOnInit() {
    this.checkTokenNearExpiration();
    setInterval(() => {
      this.checkTokenNearExpiration();
    }, this.refreshTokenTime); // 60 minutes
  }

  checkTokenNearExpiration() {
    const userSession = this.storageUtility.getLocalStorage<UserSession>(this.userSessionToken);
    const refreshToken = userSession.refresh_token;

    // Refreshes auth token 60 minute before expiration (jwt expire time in seconds)
    if (refreshToken && userSession.expires_at) {
      if (+userSession.expires_at - this.refreshTokenTime <= Date.now()) {
        const data = {
          refresh_token: refreshToken,
        };
        this.authService.authControllerRefreshToken(data).subscribe((res) => {
          userSession.access_token = res.access_token;
          userSession.expires_at = res.expires_at;
          this.storageUtility.setLocalStorage(this.userSessionToken, userSession);
        });
      }
    }
  }
}
